<template>
  <el-dialog
    title="修改密码"
    :visible.sync="_dialogVisible"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    @close="closeDialog"
    width="500px"
  >
    <el-form
      :model="formData"
      ref="listForm"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="新密码：" prop="passWord">
        <el-input
          placeholder="请输入新密码"
          type="password"
          :maxlength="32"
          v-model.trim="formData.passWord"
        />
      </el-form-item>
      <el-form-item label="确认密码：" prop="rePassWord">
        <el-input
          placeholder="请输入确认密码"
          type="password"
          :maxlength="32"
          v-model.trim="formData.rePassWord"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="_dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="btnLoading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import md5 from "js-md5";

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      }
    }
  },

  data() {
    const validateRePassWord = (rule, value, callback) => {
      if (value !== this.formData.passWord) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      btnLoading: false,
      formData: {
        passWord: "",
        rePassWord: ""
      },
      rules: {
        passWord: [
          {
            required: true,
            message: "请输入密码(8-18位，包含数字、字母和特殊字符!@#$%^&*)",
            trigger: "blur",
            pattern: /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)(?![a-zA-z\d]+$)(?![a-zA-z!@#$%^&*]+$)(?![\d!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]{8,18}$/i
          }
        ],
        rePassWord: [
          {
            required: true,
            message: "请输入密码(8-18位，包含数字、字母和特殊字符!@#$%^&*)",
            trigger: "blur",
            pattern: /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)(?![a-zA-z\d]+$)(?![a-zA-z!@#$%^&*]+$)(?![\d!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]{8,18}$/i,
            validator: validateRePassWord
          }
        ]
      }
    };
  },

  methods: {
    handleSubmit() {
      this.$refs.listForm.validate(async valid => {
        if (valid) {
          try {
            this.btnLoading = true;
            const params = {
              passWord: md5(this.formData.passWord).toUpperCase()
            };
            // const response = await updateSysUserPwd(this, params);
            // this.$message.success(response.info);
            this.btnLoading = false;
            this._dialogVisible = false;
          } catch (error) {
            this.btnLoading = false;
          }
        }
      });
    },
    closeDialog() {
      this.$refs.listForm.resetFields();
    }
  }
};
</script>
